import isRegExp from 'lodash.isregexp';

import iconUserDefault from '../../img/user/icon-user-default.png';
import mGenderPlaceholder from '../../img/user/placeholder-M.png';
import fGenderPlaceholder from '../../img/user/placeholder-F.png';
import { API_URL, PHONE_MASK } from '../config/constants';

const buildPatientProfilePicUrl = function (patient) {
	var url = API_URL + '';
	if (patient && patient.profile_image_name) {
		url +=
			'/patient_profile_images/' +
			patient.id +
			'/download/' +
			patient.profile_image_name;
	} else {
		if (patient.gender) {
			url = patient.gender == 'M' ? mGenderPlaceholder : fGenderPlaceholder;
		} else {
			url = iconUserDefault;
		}
	}
	return url;
};

const getPatientName = function (evisit) {
	let patientName;
	if (evisit.patient_dependent) {
		patientName = `${evisit.patient_dependent.dependent_name} ${evisit.patient_dependent.dependent_name_last}`;
	} else {
		patientName = `${evisit.patient.name_first} ${evisit.patient.name_last}`;
	}
	return patientName;
};

const checkNotificationPromise = () => {
	try {
		Notification.requestPermission().then();
	} catch (e) {
		return false;
	}
	return true;
};

const isMobilePhoneInvalid = (mobile_phone, returnStripped = false) => {
	let stripped = '';
	const result = [...mobile_phone].reduce((prev, char, index) => {
		let isCurrentCharInvalid = false;
		if (isRegExp(PHONE_MASK[index])) {
			isCurrentCharInvalid = !char.match(PHONE_MASK[index]);
			stripped += char;
		} else {
			isCurrentCharInvalid = PHONE_MASK[index] !== char;
		}
		return prev || isCurrentCharInvalid; // true or false
	}, false);
	if (returnStripped) {
		return stripped;
	}
	return result;
};

const getCurrentProvider = (visitRecord) => {
	let currentProvider;
	if (visitRecord.evisit_provider_transactions) {
		if (visitRecord.evisit_provider_transactions.length > 0) {
			if (visitRecord.evisit_provider_transactions[0].provider) {
				currentProvider = visitRecord.evisit_provider_transactions[0].provider;
			}
		} else {
			if (visitRecord.provider) {
				currentProvider = visitRecord.provider;
			}
		}
	}
	return currentProvider;
};

export {
	buildPatientProfilePicUrl,
	getPatientName,
	checkNotificationPromise,
	isMobilePhoneInvalid,
	getCurrentProvider,
};
